import { call, cancelled, select, take } from 'redux-saga/effects'

export function* withSagaCancelSignal<T>(f: (signal: AbortSignal) => Promise<T>) {
  const controller = new AbortController()
  const { signal } = controller
  try {
    return yield call(f, signal)
  } finally {
    if (yield cancelled()) {
      controller.abort()
    }
  }
}

export function* waitUntilSelectorEqual<T = boolean>(selector: (state) => T, expectedValue: T) {
  try {
    while (true) {
      const value = yield select(selector)
      if (value === expectedValue) return

      yield take('*')
    }
  } catch (e) {
    throw new Error(`waitUntilSelectorEqual failed: ${e}`, { cause: e })
  }
}
